import {ContractsAPI} from "../api/ContractsAPI";
import {BaseService} from "./BaseService";
import {Contract} from "../models/Contract";
import {
	actionContractFetchAllCompleted,
	actionContractFetchCompleted,
	actionContractSaveCompleted,
	actionContractDeleteCompleted,
	actionDeleteContractsCompleted
} from "../store/contracts/actions";
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions";
import {ErrorService} from "./ErrorService";
import {actionToastrInfo} from "../store/global";

export default class ContractsService extends BaseService {

	static getAll() {
		let contractsAPI: ContractsAPI = new ContractsAPI()
		contractsAPI.getAll().then(ContractsService.processResponse)
		.then((data) => actionContractFetchAllCompleted(ContractsService.responseToContracts(data)))
		.catch(error => ErrorService.handleError(error))
	}

	static save(contract: Contract) {
		let contractsAPI: ContractsAPI = new ContractsAPI()
		if (contract.id) {
			contractsAPI.put(ContractsService.contractToRequest(contract)).then(ContractsService.processResponse)
			.then((data) => {
				actionContractSaveCompleted(ContractsService.responseToContract(data))
				actionSetTabStateItem(ContractsService.responseToContract(data))
				actionSetTabItem(ContractsService.responseToContract(data))
				actionToastrInfo("Info", "Ugovor je uspešno snimljen")
			})
			.catch(error => ErrorService.handleError(error))
		} else {
			contractsAPI.post(ContractsService.contractToRequest(contract)).then(ContractsService.processResponse)
				.then((data) => {
					actionContractSaveCompleted(ContractsService.responseToContract(data))
					actionSetTabItem(ContractsService.responseToContract(data))
					actionSetTabStateItem(ContractsService.responseToContract(data))
					actionToastrInfo("Info", "Ugovor je uspešno snimljen")
				})
				.catch(error => ErrorService.handleError(error))
		}
	}

	static getOne (contract: Contract) {
		const contractsAPI: ContractsAPI = new ContractsAPI()
		contractsAPI.get(contract).then(ContractsService.processResponse)
		.then((data) => {
			actionContractFetchCompleted(ContractsService.responseToContract(data))
		})
		.catch(error => ErrorService.handleError(error))
	}

	static delete(contract: Contract) {
		const contractsAPI: ContractsAPI = new ContractsAPI()
		contractsAPI.delete(contract).then(
			(data) => {
				actionContractDeleteCompleted(contract)
				actionDeleteTabForItemId(contract.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteContracts(contracts: Contract[]) {

		const contractsAPI: ContractsAPI = new ContractsAPI()
		let count = 0;
		contracts.forEach(contract => {

			contractsAPI.delete(ContractsService.contractToRequest(contract)).then(ContractsService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(contract.id)
					if(count === contracts.length)
						actionDeleteContractsCompleted(contracts)
				}
			).catch(error => ErrorService.handleError(error))
		});
	}


	static responseToContract (data: any): Contract {
		let contract = new Contract()
		contract.title = data.title
		contract.description = data.description
		contract.number = data.number
		contract.startDate = data.startDate
		contract.endDate = data.endDate
		contract.id = data.id
		contract.uploads = data.uploads
		contract.customerId = data.customerId

		return contract
	}

	static responseToContracts (data: any) {
		return data
	}

	static contractToRequest (contract: Contract): any {
		contract.uploads = null
		return contract
	}


}
